import { Job } from "@models/job.model";
import { httpRequest } from "../../http";
import { JobSerializer } from "@models/serializers/jobSerializer";

/** Starts a job that finishes a killed "Reprocess all files" from where it stopped (MPN-1907). */
export class CommandResumeJob {
  async run(id: number): Promise<Job> {
    const response = await httpRequest<any>(
      `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/jobs/${id}/resume`,
      { method: "POST" }
    );
    return new JobSerializer().deserialize(response);
  }
}
